<template>
  <div>
    <v-row class="ma-0">
      <v-btn small>問{{ Number(no) }}</v-btn>
    </v-row>
    <v-row class="mx-0 mt-2 lead-sentence">
      <span>{{
        formGeneral.leadSentence
          ? formGeneral.leadSentence
          : "正しい形にしてください。"
      }}</span>
    </v-row>
    <v-row class="mx-0 mt-5" justify="center">
      <span class="verb-template">{{
        formGeneral.verb ? formGeneral.verb : "教えます"
      }}</span>
    </v-row>
    <div
      class="mx-0 my-7 font-weight-bold"
      :class="!formGeneral.name1 && !formGeneral.name1 ? 'text-center' : null"
    >
      {{ formGeneral.name1 }}
      <span
        v-for="(i, index) in formGeneral.answersConjugation"
        :key="index"
        class="mx-2 d-inline-flex"
        style="border-bottom: 2px solid #ccc; min-width: 1.5rem"
      ></span>
      {{ formGeneral.name2 }}
    </div>
    <v-row class="mx-0 mt-5" justify="center">
      <div style="position: relative">
        <div
          class="check-done"
          :key="minWidthCheckSelect"
          :style="`min-width:${minWidthCheckSelect}px`"
        />
        <div ref="selectAnswers" class="d-flex">
          <template v-for="(answers, index) in formGeneral.answersConjugation">
            <div class="mx-1" :key="`answers-${answers.id}`">
              <v-btn x-small color="#8a7f6f" dark>
                <v-icon>fas fa-chevron-up</v-icon>
              </v-btn>
              <ul class="mt-1">
                <li>
                  {{
                    formGeneral.wrongAnswersConjugation[index].value
                      ? formGeneral.wrongAnswersConjugation[index].value
                      : "お"
                  }}
                </li>
                <li>{{ answers.value ? answers.value : "あ" }}</li>
                <li>
                  {{
                    textRandom[Math.floor(Math.random() * textRandom.length)]
                  }}
                </li>
              </ul>
              <v-btn x-small color="#8a7f6f" dark>
                <v-icon>fas fa-chevron-down</v-icon>
              </v-btn>
            </div>
          </template>
        </div>
      </div>
    </v-row>
  </div>
</template>
<script>
export default {
  props: ["no"],
  store: ["formGeneral"],
  data() {
    return {
      minWidthCheckSelect: 0,
      textRandom: [
        "あ",
        "い",
        "う",
        "え",
        "お",
        "か",
        "き",
        "く",
        "け",
        "こ",
        "さ",
        "し",
        "す",
        "せ",
        "そ",
        "た",
        "ち",
        "つ",
        "て",
        "と",
        "な",
        "に",
        "ぬ",
        "ね",
        "の",
        "は",
        "ひ",
        "ふ",
        "へ",
        "ほ",
        "ま",
        "み",
        "む",
        "め",
        "も",
        "や",
        "ゆ",
        "よ",
        "ら",
        "り",
        "る",
        "れ",
        "ろ",
        "わ",
        "を",
        "ん",
        "が",
        "ぎ",
        "ぐ",
        "げ",
        "ご",
        "ざ",
        "じ",
        "ず",
        "ぜ",
        "ぞ",
        "だ",
        "ぢ",
        "づ",
        "で",
        "ど",
        "ば",
        "び",
        "ぶ",
        "べ",
        "ぼ",
      ],
    };
  },
  mounted() {
    this.minWidthCheckSelect = this.$refs.selectAnswers.offsetWidth + 30;
  },
  updated() {
    this.minWidthCheckSelect = this.$refs.selectAnswers.offsetWidth + 30;
  },
};
</script>

<style lang="scss" scoped>
ul {
  margin: 0;
  border: 1.5px solid #9f9a8f;
  list-style: none;
  text-align: center;
  max-width: 45px;
  font-weight: bold;
  padding: 0;
  border-radius: 4px;
  display: grid;
  background-image: linear-gradient(
    to bottom,
    rgb(219 218 216 / 50%) 30%,
    rgb(246 245 244) 30%,
    rgb(246 245 244) 65%,
    rgb(219 218 216 / 50%) 65%
  );
}
li {
  display: inline;
  text-align: center;
  padding: 4px 2px;
}
.lead-sentence {
  white-space: pre-wrap;
  padding-bottom: 8px;
  border-bottom: 5px dotted #feb798;
}
.verb-template {
  border: 1px solid #ccc;
  padding: 8px;
  border-radius: 4px;
  font-weight: bold;
}
.check-done {
  border: 2px solid #f29e39;
  min-height: 36px;
  position: absolute;
  top: 3.7rem;
  left: -28px;
}
.check-done::before {
  content: "\f30b";
  font-family: "Font Awesome 5 Free";
  display: block;
  width: 21px;
  color: #fff;
  font-size: 17px;
  font-weight: bold;
  padding-top: 4px;
  padding-left: 2px;
  background: #f29e39;
  height: 32px;
  float: left;
  margin: 0 6px 0 0;
}
button {
  word-wrap: break-word;
}
</style>